class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    // this.thumbnailSlider = null;
    this.maxPageWidth = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('max-width'));
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
    }

    if (!this.thumbnailSlider) {
      this.slider.on('mounted', () => {
        this.updateSize();

        // Fix autoHeight on mobile real devices
        setTimeout(() => {
          this.slider.refresh();
        }, 300);

      });

      // Utiliser ResizeObserver pour détecter tous les changements de taille
      this.resizeObserver = new ResizeObserver(() => {

        this.updateSize();

        if (this.querySelectorAll('img').length > 0) {
          this.slider.refresh();
        }

      });

      this.resizeObserver.observe(document.documentElement);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initMainSlider() {

    const perPageDesktop = this.getAttribute('data-per-page-desktop');
    let perPageMobile = this.getAttribute('data-per-page-mobile');

    const gap = this.getAttribute('data-gap') + 'px';

    const showArrows =
      this.getAttribute('data-show-arrows') === 'true';

    const showArrowsMobile =
      this.getAttribute('data-show-arrows-mobile') === 'true';

    const showPagination =
      this.getAttribute('data-show-pagination') === 'true';

    const showPaginationMobile =
      this.getAttribute('data-show-pagination-mobile') === 'true';

    const autoplay =
      this.getAttribute('data-autoplay') === 'true';

    const autoplaySpeed =
      this.getAttribute('data-autoplay-speed') + '000';

    const rewind =
      this.getAttribute('data-rewind') === 'true';

    if (perPageMobile === '1.8') {
      perPageMobile = 1;
    }

    return new Splide(
      this.querySelector('[data-ref="main-slider"]'),
      {
        type: 'loop',
        perPage: perPageMobile,
        perMove: 1,
        gap: gap,
        drag: true,
        snap: true,
        arrows: showArrows,
        arrowsMobile: showArrowsMobile,
        pagination: showPaginationMobile,
        autoplay: autoplay,
        interval: autoplaySpeed,
        autoHeight: true,
        lazyLoad: false,
        flickMaxPages: 1,
        flickPower: 400,
        mediaQuery: 'min',

        breakpoints: {
          750: {
            type: 'slide',
            rewind: true,
            perPage: perPageDesktop,
            pagination: showPagination,
            arrows: showArrows,
          },
        },
      }
    );

  }

  initThumbnailSlider() {

    const showArrows =
      this.getAttribute('data-show-arrows-thumbnails') === 'true';

    return new Splide(
      this.querySelector('[data-ref="thumbnail-slider"]'),
      {
        fixedWidth: 90,
        fixedHeight: 90,
        gap: 10,
        rewind: false,
        pagination: false,
        isNavigation: true,
        arrows: showArrows,

        breakpoints: {
          750: {
            fixedWidth: 70,
            fixedHeight: 70,
          },
        },
      }
    );

  }

  updateSize() {

    this.pageWidth = document.documentElement.clientWidth;

    this.sectionPadding = parseFloat(
      getComputedStyle(this.closest('.shopify-section'))
        .getPropertyValue('padding-right')
    );

    var padding = this.sectionPadding;

    if (this.pageWidth > this.maxPageWidth) {

      padding =
        (this.pageWidth - this.maxPageWidth) / 2 +
        this.sectionPadding;

    }

    this.style.width =
      `calc(100% + ${2 * padding}px)`;

    this.style.marginLeft =
      `-${padding}px`;

    this.style.marginRight =
      `-${padding}px`;

    if (this.querySelector('.splide__track')) {

      this.querySelector('.splide__track')
        .style.paddingRight = `${padding}px`;

      this.querySelector('.splide__track')
        .style.paddingLeft = `${padding}px`;

    }

    if (
      this.querySelector('.splide__arrow--prev') &&
      this.querySelector('.splide__arrow--next')
    ) {

      this.querySelector('.splide__arrow--prev')
        .style.left = `${padding + 10}px`;

      this.querySelector('.splide__arrow--next')
        .style.right = `${padding + 10}px`;

    }

  }

  remove(index) {
    this.slider.remove(index);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define(
    'slider-component',
    SliderComponent
  );
}

window.initMobileGallery = function () {

  if (window.innerWidth >= 750) return;

  const gallery =
    document.querySelector('.mobile-swiper-gallery');

  if (!gallery) return;

  // destroy old swipers

  if (gallery._mainSwiper) {

    gallery._mainSwiper.destroy(true, true);
    gallery._mainSwiper = null;

  }

  if (gallery._thumbSwiper) {

    gallery._thumbSwiper.destroy(true, true);
    gallery._thumbSwiper = null;

  }

  /*
    FILTER MOBILE GALLERY
  */

  const checkedSwatch =
    document.querySelector('.swatch-input:checked');

  if (checkedSwatch) {

    const selectedColor =
      checkedSwatch.value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

    const mainSlides =
      gallery.querySelectorAll('.msw-main-slide');

    const thumbSlidesFilter =
      gallery.querySelectorAll('.msw-thumb-slide');

    mainSlides.forEach((slide) => {

      const imageColor =
        (slide.dataset.alt || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim();

      if (
        imageColor &&
        imageColor !== selectedColor
      ) {

        slide.remove();

      }

    });

    thumbSlidesFilter.forEach((slide) => {

      const imageColor =
        (slide.dataset.alt || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim();

      if (
        imageColor &&
        imageColor !== selectedColor
      ) {

        slide.remove();

      }

    });

  }

  const thumbSlides =
    gallery.querySelectorAll('.msw-thumb-slide');

  // ===============================
  // FORCE VIDEO AUTOPLAY FUNCTION
  // ===============================

  function playAllVideos() {

    const videos =
      gallery.querySelectorAll('.msw-main-video');

    videos.forEach(video => {

      video.muted = true;

      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      const promise = video.play();

      if (promise !== undefined) {
        promise.catch(() => {});
      }

    });

  }

  // ===============================
  // THUMB SWIPER
  // ===============================

  const thumbSwiper =
    new Swiper('.msw-thumb-swiper', {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 6,
      freeMode: true,
      mousewheel: true,
      speed: 400
    });

  // ===============================
  // MAIN SWIPER
  // ===============================

  const mainSwiper =
    new Swiper('.msw-main-swiper', {

      slidesPerView: 1.2,
      spaceBetween: 10,
      loop: true,
      speed: 400,

      on: {

        init: function () {
          playAllVideos();
        },

        slideChangeTransitionEnd: function () {

          const activeIndex =
            this.realIndex;

          syncThumbs(activeIndex);

          // autoplay video again

          playAllVideos();

        }

      }

    });

  gallery._mainSwiper = mainSwiper;
  gallery._thumbSwiper = thumbSwiper;

  // ===============================
  // THUMB CLICK
  // ===============================

  thumbSlides.forEach(function (slide) {

    slide.addEventListener('click', function () {

      const index =
        parseInt(this.getAttribute('data-index'));

      mainSwiper.slideToLoop(index);

      console.log('hii clicked')

      syncThumbs(index);

      setTimeout(function () {
        playAllVideos();
      }, 200);

    });

  });

  // ===============================
  // THUMB SYNC
  // ===============================

  function syncThumbs(activeIndex) {

    thumbSlides.forEach(function (slide, i) {

      slide.classList.toggle(
        'msw-thumb-active',
        i === activeIndex
      );

    });

    const activeSlide =
      thumbSlides[activeIndex];

    if (!activeSlide) return;

    const container =
      gallery.querySelector('.msw-thumb-swiper');

    const containerHeight =
      container.offsetHeight;

    const slideOffsetTop =
      activeSlide.offsetTop;

    const slideHeight =
      activeSlide.offsetHeight;

    const idealTranslate =
      -(slideOffsetTop - (containerHeight / 2) + (slideHeight / 2));

    const wrapperHeight =
      thumbSwiper.wrapperEl.scrollHeight;

    const minTranslate =
      -(wrapperHeight - containerHeight);

    const maxTranslate = 0;

    const clampedTranslate =
      Math.min(
        maxTranslate,
        Math.max(minTranslate, idealTranslate)
      );

    thumbSwiper.wrapperEl.style.transition =
      'transform 0.4s ease';

    thumbSwiper.setTranslate(clampedTranslate);

    thumbSwiper.updateProgress();

    setTimeout(function () {

      thumbSwiper.wrapperEl.style.transition = '';

    }, 400);

  }

  // ===============================
  // HEIGHT SYNC
  // ===============================

  function syncThumbHeight() {

    const mainEl =
      gallery.querySelector('.msw-main-swiper');

    const thumbEl =
      gallery.querySelector('.msw-thumb-swiper');

    if (!mainEl || !thumbEl) return;

    const mainHeight =
      mainEl.offsetHeight;

    thumbEl.style.height =
      mainHeight + 'px';

    thumbSwiper.update();

  }

  syncThumbHeight();

  window.removeEventListener(
    'resize',
    syncThumbHeight
  );

  window.addEventListener(
    'resize',
    syncThumbHeight
  );

  const firstImg =
    gallery.querySelector('.msw-main-slide img');

  if (firstImg) {

    if (firstImg.complete) {

      syncThumbHeight();

    } else {

      firstImg.addEventListener(
        'load',
        syncThumbHeight
      );

    }

  }

  const ro =
    new ResizeObserver(syncThumbHeight);

  ro.observe(
    gallery.querySelector('.msw-main-swiper')
  );

  gallery._resizeObserver = ro;

  // ===============================
  // PAGE LOAD AUTOPLAY FIX
  // ===============================

  playAllVideos();

  document.addEventListener(
    'touchstart',
    playAllVideos,
    { once: true }
  );

};

// ===============================
// INIT
// ===============================

document.addEventListener(
  'DOMContentLoaded',
  function () {

    window.initMobileGallery();

  }
);

window.addEventListener(
  'resize',
  function () {

    window.initMobileGallery();

  }
);